import { NavContext } from "../Document"
import * as styles from "./styles.module.scss"
import cx from "classnames"
import Link from "gatsby-link"
import ListGroup from "./ListGroup"
import React, { useContext } from "react"

export interface SideNavProps {
  isOpen?: boolean
}

const SideNav: React.FC<SideNavProps> = ({ isOpen }) => {
  const { isNavOpen } = useContext(NavContext)
  return (
    <>
      <div className={styles.navigationBackground} data-qa-hidden="" />
      <nav
        className={cx({
          [styles.sideNav]: true,
          [styles.isOpen]: isOpen || isNavOpen,
        })}
      >
        <ul className={styles.sideNavList}>
          <li
            className={cx({
              [styles.item]: true,
              [styles.compact]: true,
              ["Auth"]: true,
              ["Auth-unauthenticated--on"]: true,
              ["PreapprovalContext--off"]: true,
            })}
          >
            <a href="/sign-in" className={styles.link}>
              <span className={styles.text}>Sign in</span>
            </a>
          </li>
          <li
            className={cx({
              [styles.item]: true,
              [styles.compact]: true,
              ["Auth"]: true,
              ["Auth-admin--on"]: true,
            })}
          >
            <a href="/loan-files" className={styles.link}>
              <span className={styles.text}>Loans</span>
            </a>
          </li>
          <li
            className={cx({
              [styles.item]: true,
              [styles.compact]: true,
              ["Auth"]: true,
              ["Auth-borrower--on"]: true,
              ["PreapprovalContext--on"]: true,
            })}
          >
            <a href="/sign-in" className={styles.link}>
              <span className={styles.text}>My loan</span>
            </a>
          </li>
          <li
            className={cx({
              [styles.item]: true,
              ["Auth"]: true,
              ["Auth-admin--on"]: true,
            })}
            data-qa="sign-out"
          >
            <a href="/sign-out" className={styles.link}>
              <span className={styles.text}>Sign out</span>
            </a>
          </li>
          <li
            className={cx({
              [styles.item]: true,
              ["Auth"]: true,
              ["Auth-borrower--on"]: true,
            })}
            data-qa="sign-out"
          >
            <a href="/sign-out" className={styles.link}>
              <span className={styles.text}>Sign out</span>
            </a>
          </li>
          <li
            className={cx({
              [styles.item]: true,
              [styles.compact]: true,
            })}
          >
            <Link to="/mortgage-rates/purchase" className={styles.link}>
              <span className={styles.text}>Rates for home purchase</span>
            </Link>
          </li>
          <li
            className={cx({
              [styles.item]: true,
              [styles.compact]: true,
            })}
          >
            <Link to="/mortgage-rates/refinance" className={styles.link}>
              <span className={styles.text}>Rates for refinance</span>
            </Link>
          </li>
          <ListGroup />
          <li
            className={cx({
              [styles.item]: true,
              [styles.compact]: true,
            })}
          >
            <a href="/content" className={styles.link} data-qa="blog-link">
              <span className={styles.text}>Resources</span>
            </a>
          </li>
          <li
            className={cx({
              [styles.item]: true,
              [styles.compact]: true,
            })}
          >
            <Link to="/faq" className={styles.link} data-qa="faq-link">
              <span className={styles.text}>FAQ</span>
            </Link>
          </li>
        </ul>
      </nav>
    </>
  )
}

export default SideNav
